export default __webpack_public_path__ + "static/media/akun_bank.7302566b.png";